module.exports = __webpack_public_path__ + "static/full11-14f661c6f49c94a2b3ebb85c725c9a4a.png";